import api from './api';

export interface AuthUser {
  id: string;
  email?: string | null;
  phone?: string | null;
  name?: string | null;
  createdAt?: string;
  preferencesConfigured?: boolean;
}

export interface AuthResponse {
  token: string;
  user: AuthUser;
}

export interface RequestOtpResponse {
  message?: string;
  needsConsent?: boolean;
}

export const authApi = {
  requestOtp: async (data: { email?: string; phone?: string; privacyAccepted?: boolean }): Promise<RequestOtpResponse> => {
    const res = await api.post('/api/auth/request-otp', data);
    return res.data;
  },

  verifyOtp: async (data: { email?: string; phone?: string; code: string }): Promise<AuthResponse> => {
    const res = await api.post('/api/auth/verify-otp', data);
    return res.data;
  },

  getMe: async (): Promise<{ user: AuthUser }> => {
    const res = await api.get('/api/auth/me');
    return res.data;
  },

  updateProfile: async (data: { name?: string }): Promise<{ user: AuthUser }> => {
    const res = await api.patch('/api/auth/me', data);
    return res.data;
  },
};

export const contactApi = {
  send: async (data: { name: string; email: string; category: string; message: string }): Promise<{ success: boolean }> => {
    const res = await api.post('/api/contact', data);
    return res.data;
  },
};
